// extracted by css-extract-rspack-plugin
export default {"container":"_c7b6c667","lastItem":"_a147123f"};